import React from 'react';

import ListOfCards from '../Entities/ListOfCards/ListOfCards';
import { Space } from '../../Utils/Types/Space';
import { ConsultationFilterType, UiSection } from '../../Utils/Types/UiSection';
import { Categories } from '../../Utils/Types/Posts';

interface ConsultationListOfCardsProps {
  space: Space;
  uiSection: UiSection;
}

type Config = {
  limit?: number;
  extraParams?: Record<string, any>;
};

const ConfigMapping: Record<ConsultationFilterType, Config> = {
  all: {
    limit: 3,
    extraParams: {},
  },
  pinned: {
    extraParams: {
      'filter[is_pinned]': true,
    },
  },
  ongoing: {
    limit: 3,
    extraParams: {
      'filter[ongoing]': true,
    },
  },
  ended: {
    limit: 3,
    extraParams: {
      'filter[ended]': true,
    },
  },
};

export default function ConsultationListOfCards({
  space,
  uiSection,
}: ConsultationListOfCardsProps) {
  return (
    <ListOfCards
      queryKey="featuredConsultations"
      space={space}
      postsTypes={Categories.CONSULTATION}
      trackingProps={{ category: 'Home', name: 'Click on Consultations card' }}
      viewAllHref={`/${space.slug}/consultations`}
      viewAllEnabled={space.consultations_count > 1}
      {...ConfigMapping[uiSection.consultation_type]}
    />
  );
}
